import React from "react"
import style from "./Stars.module.scss"
import cn from "classnames"

interface StarsProps {
  starsCount: number
}

export const Stars: React.FC<StarsProps> = ({ starsCount }) => {
  const getStarColor = (value: number) => {
    if ([1, 2].includes(value)) return style.bad
    if ([3].includes(value)) return style.normal
    if ([4].includes(value)) return style.good
    if ([5].includes(value)) return style.great
  }

  if (!starsCount) return <>?</>

  return (
    <div className={cn(getStarColor(starsCount), style.stars)}>
      {Array(starsCount + 1).join("★")}
    </div>
  )
}
